module.exports = new __parcel__URL__("take-item.b2a482b5.wav").toString();